import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiRequest} from "../api/apiRequest";
import type {TenantAnalyticsResponse} from "../types/tenant";

type AsyncStatus = "idle" | "loading" | "succeeded" | "failed";

export type AnalyticsState = {
  data: TenantAnalyticsResponse | null;
  status: AsyncStatus;
  error: string | null;
};

const initialState: AnalyticsState = {
  data: null,
  status: "idle",
  error: null,
};

export const fetchAnalytics = createAsyncThunk<TenantAnalyticsResponse, void>(
  "analytics/fetchAnalytics",
  async () => apiRequest<TenantAnalyticsResponse>({path: "admin/tenant-analytics"}),
);

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    reset(state) {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAnalytics.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAnalytics.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchAnalytics.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message ?? "Failed to load analytics";
      });
  },
});

export const {reset} = analyticsSlice.actions;
